import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useI18n } from "@/context/I18nContext";

export default function Blog() {
  const { t } = useI18n();
  const [posts, setPosts] = useState([]);
  useEffect(() => { api.get("/blog").then((r) => setPosts(r.data)).catch(() => {}); }, []);

  return (
    <div className="mx-auto max-w-7xl px-4 py-12">
      <h1 className="font-heading text-4xl sm:text-5xl font-extrabold tracking-tight">{t("blog.title")}</h1>
      <p className="text-gray-500 mt-2 mb-12">{t("blog.subtitle")}</p>
      <div className="grid md:grid-cols-3 gap-6">
        {posts.map((p) => (
          <Link key={p.id} to={`/blog/${p.slug}`} className="group border border-gray-200 bg-white flex flex-col" data-testid={`blog-card-${p.slug}`}>
            <div className="aspect-[16/10] overflow-hidden bg-gray-100">
              {p.cover_image && <img src={p.cover_image} alt={p.title} className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />}
            </div>
            <div className="p-6 flex-1 flex flex-col">
              <h2 className="font-heading text-xl font-bold group-hover:text-brand-red">{p.title}</h2>
              <p className="text-sm text-gray-500 mt-3 line-clamp-3 flex-1">{p.excerpt}</p>
              <span className="text-brand-red text-sm font-semibold mt-4">{t("blog.read")} →</span>
            </div>
          </Link>
        ))}
      </div>
      {posts.length === 0 && <p className="text-gray-400 py-20 text-center">{t("blog.none")}</p>}
    </div>
  );
}
